import { render, staticRenderFns } from "./MissionStateSwitcher.vue?vue&type=template&id=2b2a150a&"
import script from "./MissionStateSwitcher.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MissionStateSwitcher.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports